import React, {PropsWithChildren} from 'react';

export type envs = 'DEV' | 'UAT' | 'PROD' | 'TEST';

export const getEnvironment = (): envs => {
  if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    return 'DEV';
  }
  if (process.env.VITE_APP_BACKEND_URL?.includes('uat')) {
    return 'UAT';
  }
  if (process.env.VITE_APP_BACKEND_URL?.includes('test')) {
    return 'TEST';
  }
  return 'PROD';
};

export const DisplayIfEnv: React.FC<PropsWithChildren<{envs: envs[]}>> = ({
  envs,
  children,
}) => {
  const env = getEnvironment();
  if (envs.includes(env)) {
    return <>{children}</>;
  }
  return null;
};
